const authTypes = {
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_LOADING: "LOGIN_LOADING",
  LOGIN_FAILED: "LOGIN_FAILED",
};

export default authTypes;
